module.exports = __webpack_public_path__ + "img/icb-empty-elite-m@2x.1c966efd.png";